import React, { useEffect } from 'react'

import play from '../../assests/play2.svg'
import pause from '../../assests/pause.svg'
import music from '../../assests/music.svg'


function AudioElement({ contestDetails, isPlaying, setIsplaying, audioElem }) {
    useEffect(() => {
        if (isPlaying) {
            audioElem.current.play()
        } else {
            audioElem.current.pause()
        }
    }, [isPlaying])
    const PlayPause = () => {
        setIsplaying(!isPlaying)
    }
    return (
        <>
            <div className="md:h-[38px] w-[314px] md:max-w-[540px] bg-[#252525] rounded-full flex items-center">
                <div className="h-[26px] w-[26px] bg-[#171717] rounded-full flex m-[6px] items-center justify-center">
                    <img src={music} alt="" className="w-[14px] h-[14px]" />
                </div>
                <span className="text-[14px]">
                    {contestDetails?.source.description}
                </span>
            </div>
            <div className="h-[38px] w-[38px] bg-[#252525] rounded-full flex items-center justify-center ml-2">
                <audio src={contestDetails?.source.fileUrl} ref={audioElem} />
                <div className="cursor-pointer flex  justify-center items-center">
                    {isPlaying ? (
                        <img
                            src={pause}
                            alt=""
                            className="w-[14.51px] h-[15.83px]"
                            onClick={PlayPause}
                        />
                    ) : (
                        <img
                            src={play}
                            alt=""
                            className="w-[14.51px] h-[15.83px]"
                            onClick={PlayPause}
                        />
                    )}
                </div>
            </div>
        </>
    )
}

export default AudioElement